import { LessonKey } from '../../main/types/asset/lesson.types.ts';

export const mapIsLessonAvailable = (
  godMode: boolean,
  firstIncompleteLesson: number,
  lessonKey: LessonKey,
  isImplemented: boolean
): boolean => {
  if (!isImplemented) {
    return false;
  }

  return godMode || lessonKey.lesson <= firstIncompleteLesson;
};
